<ps-ui-header
  (closeSurvey)="goToDashboard($event)"
  (openServiceAccountModal)="selectBuyer($event)"
  [isLaunchSurvey]="true"
></ps-ui-header>
<ps-ui-quota-mapper></ps-ui-quota-mapper>
